import React, { useState, useEffect, useRef, useContext } from "react";
import Nav from "./Nav";
import Toolbar from "@material-ui/core/Toolbar";
import Alert from '@material-ui/lab/Alert';
// importing the main container
import Container from "@material-ui/core/Container";
// main card import that holds patient details and the action buttons
// ------------------------
import Card from "@material-ui/core/Card";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
// replacement for the classic <hr> from material ui
import Divider from "@material-ui/core/Divider";
// standard text from material ui
import { UserContext } from "./UserContext";
import Typography from "@material-ui/core/Typography";
// styles for the components from material ui
import { makeStyles } from "@material-ui/core/styles";
// input
import TextField from "@material-ui/core/TextField";
// button
import Button from "@material-ui/core/Button";
// date picker for admission
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
// Dropdown
import MenuItem from "@material-ui/core/MenuItem";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";

export default function PatientCreate(props) {
  // make a post request - DONE
  // make the prescriptions an array, watch colt steele bootcamp comments - DONE
  // make the surgeries an array, watch colt steele bootcamp comments - NOT DONE YET
  // add a field for prescriptions and notes - NOT DONE YET

  // defining patient state and setting default value of patient status to Active after creation
  const DRAFT_KEY = 'sz_app_draft';
  // permanently killed players get their own draft, so a full application draft is never restored into the new character form
  const PK_DRAFT_KEY = 'sz_pk_draft';
  // answers to removed questions that can still be in drafts saved before they were removed
  const REMOVED_FIELDS = ['joinReason', 'positiveTraits', 'negativeTraits', 'currentFactions', 'interestedFaction', 'ScenariosValueOfLife', 'sportsmanship', 'rulebreakInfrontOfYou'];
  const hasAnswers = (answers) => Object.values(answers).some((value) => value);

  const { user } = useContext(UserContext);
  const [application, setApplication] = useState({ status: "Active", steamID: user.steamId, discordID: user.discordId });
  const [whitelistStatus, setWhitelistStatus] = React.useState();
  const [cooldown, setCooldown] = React.useState();
  const [isPKd, setIsPKd] = React.useState(false);
  const [pendingDraft, setPendingDraft] = React.useState(null);
  const [draftRestored, setDraftRestored] = React.useState(false);
  const draftKey = isPKd ? PK_DRAFT_KEY : DRAFT_KEY;

  const fetchWhitelistStatus = async () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/admin/user/${user._id}/whitelist`, {credentials: 'include'})
    .then((response) => response.json())
    .then((json) => setWhitelistStatus(json));
  };

  const fetchPKStatus = async () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/admin/user/${user._id}/pkd`, {credentials: 'include'})
      .then((r) => r.json())
      .then((pkd) => setIsPKd(pkd));
  };

  const fetchCooldown = async () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/admin/user/${user._id}/cooldown`, {credentials: 'include'})
    .then((response) => response.json())
    .then((json) => isBefore(json));
  };

  const isBefore = async (cd) => {
    const then = new Date();
    const now = then.toISOString();
    if (cd != 'No') {
      const result = now < cd;
      if (result) {
        setCooldown(cd);
      } else {
        setCooldown('No Cooldown')
      }
    } else {
      setCooldown('No Cooldown')
    }   
  }

  useEffect(() => {
    fetchWhitelistStatus();
    fetchCooldown();
    fetchPKStatus();
  }, []);

  useEffect(() => {
    setPendingDraft(null);
    const draft = localStorage.getItem(draftKey);
    if (draft) {
      try {
        const saved = JSON.parse(draft);
        REMOVED_FIELDS.forEach((key) => delete saved[key]);
        if (hasAnswers(saved)) setPendingDraft(saved);
      } catch {
        localStorage.removeItem(draftKey);
      }
    }
  }, [draftKey]);

  const applyDraft = () => {
    if (!pendingDraft) return;
    setApplication((prev) => ({ ...prev, ...pendingDraft }));
    setPendingDraft(null);
    setDraftRestored(true);
  };

  const discardDraft = () => {
    localStorage.removeItem(draftKey);
    setPendingDraft(null);
  };

  useEffect(() => {
    const { steamID, discordID, status, ...draft } = application;
    if (!hasAnswers(draft)) return;
    localStorage.setItem(draftKey, JSON.stringify(draft));
  }, [application, draftKey]);
  // Post request to add a patient
  // styling
  const useStyles = makeStyles({
    root: {
      overflowWrap: 'break-word',
    },
    bullet: {
      display: "inline-block",
      margin: "0 2px",
      transform: "scale(0.8)",
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
    sex: {},
  });

  const classes = useStyles();

  const [sex, setSex] = React.useState();
  const handleChangeSex = (event) => {
    setSex(event.target.value);
    setApplication({ ...application, sex: event.target.value });
  };
  const sexSelect = [
    {
      value: "5",
    },
    {
      value: "10",
    },
    {
      value: "15",
    },
    {
      value: "20",
    },
  ];

  const BACKSTORY_MIN_WORDS = 200;
  const countWords = (text) => (text ? text.trim().split(/\s+/).filter(Boolean).length : 0);
  const backstoryWords = countWords(application.backgroundStory);

  const [checked, setChecked] = React.useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const [error, setError] = useState();

  const onSubmit = (e) => {
    e.preventDefault();
    if (backstoryWords < BACKSTORY_MIN_WORDS) {
      setError(`Your backstory needs at least ${BACKSTORY_MIN_WORDS} words!`);
    } else if (checked === false) {
      setError('You cannot proceed without agreeing to the checkbox.');
    } else {
      fetch(`${process.env.REACT_APP_API_URL}/api/applications/submit`, {
        method: "POST",
        credentials: 'include',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(application),
      })
      .then((res) => res.json())
      .then(() => {
        localStorage.removeItem(draftKey);
        props.history.push(`/my/applications`);
      });
    }
  };

  function diff_hours(dt2, dt1) 
  {
 
   var diff =(dt2.getTime() - dt1.getTime()) / 1000;
   diff /= (60 * 60);
   return Math.abs(Math.round(diff));
   
  }

  function diff_dates(dt2, dt1) {
    var seconds = Math.floor((dt2 - (dt1))/1000);
    var minutes = Math.floor(seconds/60);
    var hours = Math.floor(minutes/60);
    var days = Math.floor(hours/24);
    
    hours = hours-(days*24);
    minutes = minutes-(days*24*60)-(hours*60);
    seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
    return `${hours} hours ${minutes} minutes ${seconds} seconds`
}
  const form = useRef();
  return (
    <div>
      <Nav />
      <br></br>
      {cooldown && cooldown === 'No Cooldown' ?
      <Container maxWidth="md">
      {(whitelistStatus != "Accepted" && whitelistStatus != "Pending" && whitelistStatus != "Whitelisted" && whitelistStatus != "Banned" ) ?
        <ValidatorForm
          ref={form}
          onSubmit={onSubmit}
          onError={(errors) => console.log(errors)}
        >
          {/* // <form className={classes.root} noValidate autoComplete="off" onSubmit={onSubmit}> */}
          <Card className={classes.root} variant="outlined">
            <CardContent>
              <Typography variant="h6" component="h2">
                {isPKd ? 'NEW CHARACTER APPLICATION' : 'APPLICATION DETAILS'} -{" "}
                <span style={{ color: "gray" }}>{isPKd ? 'Permanent Kill Re-Application' : 'Whitelist Application'}</span>
              </Typography>
              {isPKd && (
                <Alert severity="warning" style={{ marginTop: 8, marginBottom: 8 }}>
                  You have been permanently killed. Fill in your new character's details below. Rule knowledge questions are carried over from your previous application.
                </Alert>
              )}
              {pendingDraft && (
                <Alert severity="info" style={{ marginTop: 8, marginBottom: 8 }}
                  action={
                    <span>
                      <Button size="small" color="inherit" variant="outlined" style={{ marginRight: 6 }} onClick={applyDraft}>
                        RESTORE
                      </Button>
                      <Button size="small" color="inherit" onClick={discardDraft}>
                        DISCARD
                      </Button>
                    </span>
                  }
                >
                  You have a saved draft from a previous session.
                </Alert>
              )}
              {draftRestored && (
                <Alert severity="success" style={{ marginTop: 8, marginBottom: 8 }}>
                  Draft restored.
                </Alert>
              )}
              <Divider />
              <Typography variant="body2" component="p">
                <TextValidator
                  id="standard-basic"
                  fullWidth
                  label="Discord ID"
                  disabled
                  InputLabelProps={{ shrink: true }}
                  name="application[discordID]"
                  value={user.discordId}
                  validators={["required"]}
                  errorMessages={["Discord ID missing."]}
                />
              </Typography>
              <Divider />
              <Typography variant="body2" component="p">
                <TextValidator
                  id="standard-basic"
                  label="What is your character's first and last name?(Name on game launcher must match)"
                  fullWidth
                  name="application[characterName]"
                  InputLabelProps={{ shrink: true }}
                  value={application.characterName}
                  onChange={(e) =>
                    setApplication({ ...application, characterName: e.target.value })
                  }
                  validators={["required"]}
                  errorMessages={["Please add your character's name!"]}
                />
              </Typography>
              <Divider />
              <Typography variant="body2" component="p">
                <TextValidator
                  id="standard-basic"
                  fullWidth
                  label="STEAMID"
                  disabled
                  InputLabelProps={{ shrink: true }}
                  name="application[steamID]"
                  value={user.steamId}
                  onChange={(e) =>
                    setApplication({ ...application, steamID: e.target.value })
                  }
                  validators={["required"]}
                  errorMessages={["Please add your SteamID!"]}
                />
              </Typography>
              <Divider />
              {!isPKd && (
              <>
              <Typography variant="body2" component="p">
                <TextValidator
                  id="standard-basic"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  multiline
                  label="Explain how you found out about our Server?"
                  name="application[foundOutExplanation]"
                  value={application.foundOutExplanation}
                  onChange={(e) =>
                    setApplication({ ...application, foundOutExplanation: e.target.value })
                  }
                  validators={["required"]}
                  errorMessages={["Please fill this field!"]}
                />
              </Typography>
              <Divider />
              <Typography variant="body2" component="p">
                <TextValidator
                  id="standard-basic"
                  fullWidth
                  multiline
                  InputLabelProps={{ shrink: true }}
                  label="Do you have roleplay experience on any other games? If so, which?"
                  name="application[roleplayExperience]"
                  value={application.roleplayExperience}
                  onChange={(e) =>
                    setApplication({ ...application, roleplayExperience: e.target.value })
                  }
                  validators={["required"]}
                  errorMessages={["Please fill this field!"]}
                />
              </Typography>
              <Divider />
              <Typography variant="body2" component="p">
                <TextValidator
                  id="standard-basic"
                  fullWidth
                  label="Enter the hidden word found on our Web Page. (Hint: do not skim read, it's a random combination of words and numbers in between the rules)"
                  name="application[hiddenWord]"
                  InputLabelProps={{ shrink: true }}
                  value={application.hiddenWord}
                  onChange={(e) =>
                    setApplication({ ...application, hiddenWord: e.target.value })
                  }
                  validators={["required"]}
                  errorMessages={["Please fill this field!"]}
                />
              </Typography>
              <Divider />
              <Typography variant="body2" component="p">
                <TextValidator
                  id="standard-basic"
                  fullWidth
                  multiline
                  label="What does NVL mean? When does it apply?"
                  name="application[valueOfLifeExplanation]"
                  InputLabelProps={{ shrink: true }}
                  value={application.valueOfLifeExplanation}
                  onChange={(e) =>
                    setApplication({ ...application, valueOfLifeExplanation: e.target.value })
                  }
                  validators={["required"]}
                  errorMessages={["Please fill this field!"]}
                />
              </Typography>
              <Divider />
              </>
              )}
              <Typography variant="body2" component="p">
                <TextValidator
                  id="standard-basic"
                  fullWidth
                  multiline
                  InputLabelProps={{ shrink: true }}
                  label={`Give a backstory of your character only before entering the Zone. Do not include anything that happens inside the Zone. (${BACKSTORY_MIN_WORDS} words minimum)`}
                  name="application[backgroundStory]"
                  value={application.backgroundStory}
                  onChange={(e) =>
                    setApplication({ ...application, backgroundStory: e.target.value })
                  }
                  helperText={`${backstoryWords} words (minimum ${BACKSTORY_MIN_WORDS})`}
                  validators={["required"]}
                  errorMessages={["Please fill this field!"]}
                />
              </Typography>
              <Divider />
              {!isPKd && (
              <>
              <Typography variant="body2" component="p">
                <TextValidator
                  id="standard-basic"
                  fullWidth
                  multiline
                  label="When is it allowed to go out of character (OOC) while playing on the server, and what do you do if someone breaks a rule in front of you?"
                  name="application[allowedOOC]"
                  InputLabelProps={{ shrink: true }}
                  value={application.allowedOOC}
                  onChange={(e) =>
                    setApplication({ ...application, allowedOOC: e.target.value })
                  }
                  validators={["required"]}
                  errorMessages={["Please fill this field!"]}
                />
              </Typography>
              <Divider />
              <Typography variant="body2" component="p">
                <TextValidator
                  id="standard-basic"
                  fullWidth
                  label="You are holding someone up, you give them a demand to put their hands up or you will shoot. How much time must you give them to comply?"
                  name="application[initiationComplianceSeconds]"
                  InputLabelProps={{ shrink: true }}
                  value={application.initiationComplianceSeconds}
                  onChange={(e) =>
                    setApplication({ ...application, initiationComplianceSeconds: e.target.value })
                  }
                  validators={["required"]}
                  errorMessages={["Please fill this field!"]}
                />
              </Typography>
              <Divider />
              <Typography variant="body2" component="p">
                <TextValidator
                  id="standard-basic"
                  fullWidth
                  multiline
                  label="In your own words, give a detailed explanation of the NLR rule."
                  name="application[nlrExplanation]"
                  InputLabelProps={{ shrink: true }}
                  value={application.nlrExplanation}
                  onChange={(e) =>
                    setApplication({ ...application, nlrExplanation: e.target.value })
                  }
                  validators={["required"]}
                  errorMessages={["Please fill this field!"]}
                />
              </Typography>
              <Divider />
              <Typography variant="body2" component="p">
                <TextValidator
                  id="standard-basic"
                  fullWidth
                  multiline
                  label="You were part of an encounter in which you died, when can you grab your gear?"
                  name="application[gearGrab]"
                  InputLabelProps={{ shrink: true }}
                  value={application.gearGrab}
                  onChange={(e) =>
                    setApplication({ ...application, gearGrab: e.target.value })
                  }
                  validators={["required"]}
                  errorMessages={["Please fill this field!"]}
                />
              </Typography>
              <Divider />
              </>
              )}
              <FormControlLabel control={<Checkbox checked={checked} onChange={handleChange} />} label="Please confirm you understand that if you change your character for any reason you must submit a new whitelist application with your new character's backstory." />
              <Divider />
        {/* <Typography variant="body2" component="p">
        <TextValidator
        id="standard-basic" 
        label="SUPERVISOR"
        name="patient[supervisor]"
        value={patient.supervisor}
        validators={['required']}
        errorMessages={['Please add the supervising doctor of the patient!']}
        onChange={e => setPatient({...patient, supervisor: e.target.value})} 
        />
        </Typography>
        <Divider />                 */}
            </CardContent>
            {error &&
             <Alert severity="error">{error}</Alert>
            }
            <CardActions>
              <Button
                type="submit"
                size="small"
                color="primary"
                variant="outlined"
              >
                SUBMIT
              </Button>
            </CardActions>
          </Card>
        </ValidatorForm>
        :
        <h1>Cannot perform this action because your application is {whitelistStatus}</h1>
        }
      </Container> : 
      <Container maxWidth="md"> <h1>A cooldown has been applied for the next {cooldown != 'No Cooldown' ? diff_dates(new Date(cooldown), new Date()) : ''} hours</h1></Container>
}
    </div>
  );
}
